/**
 * 基版コピー・フェーズ管理画面　フェーズ確定情報VOクラス
 */
export class KYMW2700PhaseFixationModel {

  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分

  public phaseCode: string = null;                                              // フェーズコード

  // 媒体フェーズ同一の確認有無フラグ(tureの場合、チェック無しでフェーズ確定処理を行う。)
  public forcedPhaseFixationFlag: boolean = <boolean>false;
  public commitDataBaseFlag: boolean = <boolean>false;                          // フェーズ確定DataBaseCommit状態

  // フェーズスキップロック解除フラグ
  public phaseSkipFlag: boolean = <boolean>false;

  // 初回フラグ
  public isFirstFlg: boolean = <boolean>false;
}
